import {z} from "zod";
import {ListCustomerOffersQueryParams} from "@project/sdk/sales/zod";

export const listCustomerOffersSearchSchema = ListCustomerOffersQueryParams.extend({
  page: ListCustomerOffersQueryParams.shape.page.catch(1),
  perPage: ListCustomerOffersQueryParams.shape.perPage.catch(20),
  sortKey: ListCustomerOffersQueryParams.shape.sortKey.catch("name"),
  sortDir: ListCustomerOffersQueryParams.shape.sortDir.catch("asc"),
  expedientId: ListCustomerOffersQueryParams.shape.expedientId.catch(undefined),
  offerOrdinal: ListCustomerOffersQueryParams.shape.offerOrdinal.catch(undefined),
  version: ListCustomerOffersQueryParams.shape.version.catch(undefined),
  status: ListCustomerOffersQueryParams.shape.status.catch(undefined),
  q: ListCustomerOffersQueryParams.shape.q
    .transform((value) => value?.trim() || undefined)
    .catch(undefined)
    .optional(),
  language: ListCustomerOffersQueryParams.shape.language.catch(undefined),
  currencyCode: ListCustomerOffersQueryParams.shape.currencyCode.catch(undefined),
  statuses: ListCustomerOffersQueryParams.shape.statuses.catch(undefined),
  latestOnly: z
    .union([z.boolean(), z.enum(["true", "false"]).transform((value) => value === "true")])
    .optional()
    .transform((value) => ListCustomerOffersQueryParams.shape.latestOnly.parse(value))
    .catch(false),
});
export type ListCustomerOffersSearchInput = z.input<typeof listCustomerOffersSearchSchema>;
export type ListCustomerOffersSearch = z.output<typeof listCustomerOffersSearchSchema>;
